<template>
  <div class="div-center">
    <a-card style="width: 100%" :bordered="false" v-if="hasManyTenants">
      <img
        src="/svg/undraw/undraw_two_factor_authentication_namy.svg"
        style="width:50%;"
        class="center"
        alt="Create your tenant"
        slot="cover"
      />
      <div class="row justify-content-center">
        <h3 style="padding:10px;">No Active Tenant</h3>
        <p>Swtich your tenant using tenant switcher on top <a-avatar shape="square" size="large" icon="switcher" style="background: #002e66;" /></p>
        <a-divider>OR</a-divider>
        <a-button type="primary" shape="round" @click="showDrawer">
          Create new tenant
          <a-icon type="arrow-right" style="fontSize:20px;" />
        </a-button>
      </div>
    </a-card>
    <a-card style="width: 100%" v-else :bordered="false">
      <img
        src="/svg/undraw/undraw_two_factor_authentication_namy.svg"
        style="width:50%;"
        class="center"
        alt="Create your tenant"
        slot="cover"
      />
      <div class="row justify-content-center">
        <h3 style="padding:10px;">Get Started</h3>
        <p>Looks like you have not created any tenant yet. Create your first Axioms tenant and start managing user identities and access control.</p>
        <a-button type="primary" shape="round" @click="showDrawer">
          Create new tenant
          <a-icon type="arrow-right" style="fontSize:20px;" />
        </a-button>
      </div>
    </a-card>
  </div>
</template>
<script>
export default {
  methods: {
    showDrawer() {
      this.$store.dispatch("ui/showDrawer", {
        drawer_name: "create_tenant"
      });
    }
  },
  computed: {
      hasManyTenants() {
            var userinfo = this.$store.state.axioms.userinfo;
            return userinfo && userinfo.orgs.length >= 1 ? true : false;
      }
  },
};
</script>
